import ReactHtmlParser from "react-html-parser";
import SntWarning from "@cleanup/components/SntWarning";
import StringUtils from "@/utils/StringUtils";
import { LanguageKey } from "@/types/generated/LanguageKey";
import { translate } from "@/hooks/useLanguage";
import usePagePermissionCheck from "./usePagePermissionCheck";

interface PagePermissionWarningProps {
  pageName?: string;
  /** Notified after each check: true when the selected org may access the page */
  onAccessResolved?: (hasAccess: boolean) => void;
}

/**
 * Classic yellow warning banner shown when the selected org's plan lacks the
 * page's required feature. For pages that blank their content instead, use
 * FeatureNotInPlanEmptyState (same check, centered plan-upsell presentation).
 */
const PagePermissionWarning: React.FC<PagePermissionWarningProps> = ({
  pageName,
  onAccessResolved,
}) => {
  const { hasAccess, orgName, requiredFeatures, orgId } =
    usePagePermissionCheck(pageName, onAccessResolved);

  if (hasAccess) {
    return null;
  }

  return (
    <div className="mt-2 mb-2">
      <SntWarning textClassName="d-flex justify-content-center">
        {ReactHtmlParser(
          translate(LanguageKey.organization_key) +
            " <b>" +
            orgName +
            "</b> " +
            translate(LanguageKey.has_no_access_to_feature) +
            (requiredFeatures && " <b>" + requiredFeatures + "</b>. ") +
            StringUtils.replaceStr(
              translate(LanguageKey.change_for_this_org_to_enable_it),
              ` <a href='/product_plan?org=${orgId}'>` +
                translate(LanguageKey.platfrom_plan) +
                "</a> "
            )
        )}
      </SntWarning>
    </div>
  );
};

export default PagePermissionWarning;
